module.exports = __webpack_public_path__ + "img/3.e5bd8ec0.png";